
import ForumPostDetail from '../../components/ForumPostDetail';

export default function CreatorsDetailPage() {
  return <ForumPostDetail categoryId="creators" />;
}
